<template>
  <span
    :class="[_['tv-iconfont'], _[`iconfont-${name}`]]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      name: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" module>
  @font-face {
    font-family: 'tv-iconfont';
    src: url('data:font/woff;charset=utf-8;base64,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')
      format('woff');
  }

  .tv-iconfont {
    font-family: 'tv-iconfont' !important;
    font-size: 1em;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .iconfont-home-search::before {
    content: '\efaa';
  }

  .iconfont-home-address::before {
    content: '\efa3';
  }

  .iconfont-home-favorite::before {
    content: '\efa5';
  }

  .iconfont-home-coupon::before {
    content: '\efa6';
  }

  .iconfont-home-order::before {
    content: '\efa7';
  }

  .iconfont-home-cart::before {
    content: '\efa8';
  }

  .iconfont-search::before {
    content: '\efa0';
  }

  .iconfont-delete::before {
    content: '\efa1';
  }

  .iconfont-backspace::before {
    content: '\efa2';
  }

  .iconfont-plus::before {
    content: '\ef9e';
  }

  .iconfont-minus::before {
    content: '\ef9f';
  }
</style>
